// O: OpenStreetMap
// O:R:123456 (relation)

import { LocationIQReverseLocation } from '@habity/types';

// A: Area
// A:123456 (id)

export const getShortOSMType = (osmType: string) => {
  switch (osmType) {
    case 'relation':
      return 'R';
    case 'way':
      return 'W';
    case 'node':
      return 'N';
    default:
      return '';
  }
};

export const getOSMType = (osmTypeShort: string) => {
  switch (osmTypeShort) {
    case 'R':
      return 'relation';
    case 'W':
      return 'way';
    case 'N':
      return 'node';
    default:
      return '';
  }
};

export const getOSMPlaces = (places?: string[] | null) => {
  return places ? places.filter((p) => p.startsWith('O:')) : [];
};

export const getOSMString = (location: LocationIQReverseLocation) => {
  const { osm_type, osm_id } = location || {};
  return `O:${getShortOSMType(osm_type)}:${osm_id}`;
};

export const getShortOSMTypeFromString = (osmString: string) => {
  return osmString.split(':')[1];
};

export const getOSMDataFromString = (osmString: string) => {
  const splitted = osmString.split(':');
  return {
    osm_type: splitted[1],
    osm_id: Number(splitted[2]),
  };
};
